import { Link } from "react-router-dom";
import { Container } from "../components/layout/Container.jsx";
import { SEO } from "../lib/seo.jsx";

export default function NotFoundPage() {
  return (
    <>
      <SEO title="Page not found" />
      <Container className="flex min-h-[60vh] flex-col items-center justify-center text-center">
        <p className="eyebrow">Error 404</p>
        <h1 className="mt-3 font-display text-5xl text-text-primary">Page not found</h1>
        <p className="mt-3 max-w-md text-text-secondary">
          {"The page you're looking for doesn't exist — it may have moved, or the link is broken."}
        </p>
        <Link to="/" className="mt-8 btn-primary">
          Back to home
        </Link>
      </Container>
    </>
  );
}
